var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',[_vm._v("Value")]),_c('editor',{attrs:{"input":false,"formula":true},model:{value:(_vm.formulaInfo.data.text),callback:function ($$v) {_vm.$set(_vm.formulaInfo.data, "text", $$v)},expression:"formulaInfo.data.text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }